const styles = {
  linkContainer: {
    paddingTop: 'medium',
    fontSize: 'inherit'
  },
  bottom: {
    paddingBottom: 'medium'
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline'
  },
  title: {
    flex: 1,
    overflow: 'hidden'
  },
  icon: {
    fontSize: 'large',
    cursor: 'pointer',
    paddingVertical: '0',
    paddingRight: '0',
    paddingLeft: 'small'
  },
  contentTab: {
    paddingLeft: 'small'
  },
  content: {
    paddingLeft: 'small',
    overflow: 'hidden',
    maxHeight: 0,
    transition: '0.4s max-height'
  },
  contentOpen: {
    maxHeight: '100%'
  },
  separator: {
    borderBottomWidth: '1px',
    borderColor: 'section',
    borderBottomStyle: 'solid'
  },
  tighter: {
    paddingTop: 'xsmall'
  }
};

export default styles;
